import { GraphQLClient } from 'graphql-request';

export const publicGraphqlClient = new GraphQLClient(
    new URL('/api/public/graphql', window.location.origin).toString(),
    { credentials: 'same-origin' },
);
